import React from 'react';

import AuthUserContext from './AuthUserContext';
import authHandler, { profile } from './AuthHandler';

const withAuthentication = (Component) =>
	class WithAuthentication extends React.Component {
		state = {
			userProfile: null,
		};

		componentDidMount() {
			authHandler.onStateChanged((userProfile) => {
				console.log('Authentication', 'User profile changed', userProfile, profile);
				userProfile ? this.setState({ userProfile }) : this.setState({ userProfile: null });
			});
		}

		render() {
			const { userProfile } = this.state;
			console.log('Profile:', userProfile);

			return (
				<AuthUserContext.Provider value={userProfile}>
					<Component {...this.props} />
				</AuthUserContext.Provider>
			);
		}
	};

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/utilities/WithAuthentication.js